export enum Language {
  enUS = 'en-US',
  frCA = 'fr-CA',
}
